import * as React from "react";
import { useParams } from "react-router-dom";

import QuotaForm from "../../../components/Forms/BrfPaymentGroupQuota/FlowForm/FlowForm";

export default () => {
  const { paymentGroupId, id } = useParams();

  return <QuotaForm method="PATCH" id={id} paymentGroupId={paymentGroupId}/>;
};
